'use strict'

import React from 'react';
import request from 'superagent';
import uuid from 'uuid';

import AreaForm from '../components/AreaForm.jsx';
import ProjectMenu from '../components/ProjectMenu.jsx';
import Layout from '../Layout.jsx';
import {ReportMessage} from '../log/HighlightReport.jsx';

import formDefinition from '../definition/formDefinition.js';
import Translations from '../../app/utils/translations.js';

let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
  ]).
  loadVariants([
    require('./labels/norwegian#noProject.js')
  ]);


export class ProjectDefinition extends React.Component {
  constructor(props) {
    super(props);
    let labels=translations.getTranslation(this.props.language,this.props.variant);
    let definition=Object.assign({},this.props.project,{
     _progress: "stakeholders",
     objectivesSummary: this.props.project.objectivesSummary!==undefined
       ? this.props.project.objectivesSummary.map(aspect=>Object.assign({},aspect,{
           name: labels.aspects[aspect.id],
           description: aspect.description
         }))
       : ["time","scope","cost","quality","risk"]
         .map(id=>({
            id:id,
            name:labels.aspects[id],
            description: id==="scope" ? labels.aspects.scopeDescription : undefined
          })
        ),
     projectScope: (this.props.project.projectScope!==undefined ? this.props.project.projectScope :[]),
     benefitsDescription: this.props.project.benefitsDescription!==undefined ? this.props.project.benefitsDescription : this.props.project.tolerances,
     scopeExclusions: this.props.project.scopeExclusions!==undefined ? this.props.project.scopeExclusions : this.props.project.scopeAndExclusions,
     constraints: this.props.project.constraints!==undefined ? this.props.project.constraints : this.props.project.constraintsAndAssumptions,
     stakeholders: this.props.project.stakeholders!==undefined ? this.props.project.stakeholders : this.props.project.usersAndStakeholders
   });
   this.state={
      definition: definition,
      lastSaved: definition
    };
    this.warningOnLeave=this.changeWarningOnLeave.bind(this)
  }


  sendCommand(command,success) {
    request
      .post("/")
      .send(command)
      .end(function(error, response) {
        if (error===null && response.status===200) {
          var message=JSON.parse(response.text);
          if (message.status==="OK") {
            console.log("Success for command '"+command.type+"'");
            success(message.project);
          } else {
            console.log("Error: "+message.message);
            window.alert("Not able to update project definition");
          }
        } else {
          console.log("Error: "+error+", got "+response.status+" with message "+response.text);
          window.alert("Not able to update project definition");
        }
      });
  }

  update(project) {
    var strippedProject={id:project.id};
    [].concat.apply([],formDefinition.map(tab=>tab.fields)).map(field=>field.name).forEach(field=>{
      strippedProject[field]=this.state.definition[field];
    });
    this.sendCommand({type:"updateProjectDefinition", project:strippedProject}, function(updatedProject) {
      this.setState({
        definition: Object.assign({},this.state.definition, {
          _currentProgress: project._progress
        }),
        modified:undefined,
        lastSaved:this.state.definition
      });
    }.bind(this));
  }

  handleFieldChange(fieldName) {
    return (event)=>{
      let labels=translations.getTranslation(this.props);
      var value=event.target.value;
      if (event.target.name==="projectScope") {
        value=value
          .map(item=>item.id===undefined ? Object.assign({},item,{id:uuid.v4()}) : item)
          .map(item=>
            item.text==="" && item.items!==undefined && item.items.length>0
              ? Object.assign({},item,{text:labels.messages.deletedScope})
              : item);
      }
      this.setState({
        definition:Object.assign({},this.state.definition,{
          [event.target.name]:value
        }),
        modified:true
      });
    };
  }

  hasChanged(lastSaved) {
    return formDefinition.map(area=>
      area.fields!==undefined && area.fields.map(field=>
        JSON.stringify(lastSaved[field.name])!==JSON.stringify(this.state.definition[field.name])
      )
      .reduce((value,result)=>result || value)
    ).reduce((value,result)=>result || value);
  }

  changeWarningOnLeave(e) {
    if (this.hasChanged(this.state.lastSaved)) {
      e.returnValue="Do you want to keep changes?";
      return "Do you want to keep changes?";
    }
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.warningOnLeave);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload",this.warningOnLeave);
  }


  render() {
    let labels=translations.getTranslation(this.props.language,this.props.variant);
    let areas=translations.createTranslatedForm(formDefinition,this.props.language,this.props.variant);
    var selected=0;
    if (typeof window!=="undefined" && window.location.hash.length>0) {
      areas.forEach((area,index) =>{
        if (area.name===window.location.hash.slice(1)) {
          selected=index;
        }
      })
    }
    return (
      <div style={{marginTop: 20, display:"flex", justifyContent:"center", flexWarp:"wrap"}}>
        <div style={{width:1016}}>
          {this.props.showMessage!==undefined && selected===2
            && this.state.definition.projectScope!==undefined
            && this.state.definition.projectScope.filter(item=>item.id===undefined).length>0
              ? (
            <div style={{marginBottom:10}}>
              <ReportMessage message={labels.messages[this.props.showMessage]}/>
            </div>
          ) : null}
          <AreaForm
            {...this.props}
            display="tab"
            areas={areas}
            item={this.state.definition}
            label={labels.definition}
            selected={selected}
            onUpdate={this.update.bind(this)}
            modified={this.state.modified}
            handleFieldChange={this.handleFieldChange.bind(this)}
            onCancel={()=>window.location="."}
          />
        </div>
      </div>
    );
  }
}

export default class ProjectDefinitionPage extends React.Component {
  render() {
    var menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props}/> : undefined;
    return (
      <Layout {...this.props} projectMenu={menu}>
        <ProjectDefinition {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/definition/ProjectDefinition.jsx